import Urls from '../Urls'
import { axiosInstance } from "./AxiosInstance"
class LoginRegisterReq {
    Login = (data) => {
        return axiosInstance({
            method: 'post',
            url: Urls.login(),
            data,
        })
    }
    SendPhoneVerifyCode = (data) => {
        return axiosInstance({
            method: 'post',
            url: Urls.SendPhoneVerifyCode(),
            data,
        })
    }
    SendEmailVerifyCode = (data) => {
        return axiosInstance({
            method: 'post',
            url: Urls.SendEmailVerifyCode(),
            data,
        })
    }
    PhoneVerifyCode = (data) => {
        return axiosInstance({
            method: 'post',
            url: Urls.PhoneVerifyCode(),
            data,
        })
    }
    EmailVerifyCode = (data) => {
        return axiosInstance({
            method: 'post',
            url: Urls.EmailVerifyCode(),
            data,
        })
    }
    forgotPasswordSendPhone = (data) => {
        return axiosInstance({
            method: 'post',
            url: Urls.forgotPasswordSendPhone(),
            data,
        })
    }
    forgotPasswordSendEmail = (data) => {
        return axiosInstance({
            method: 'post',
            url: Urls.forgotPasswordSendEmail(),
            data,
        })
    }
    ForgotPasswordVerifyPhoneCode = (data) => {
        return axiosInstance({
            method: 'post',
            url: Urls.ForgotPasswordVerifyPhoneCode(),
            data,
        })
    }
    ForgotPasswordVerifyEmailCode = (data) => {
        return axiosInstance({
            method: 'post',
            url: Urls.ForgotPasswordVerifyEmailCode(),
            data,
        })
    }
    ForgotPassowrdPhoneUpdate = (data) => {
        return axiosInstance({
            method: 'post',
            url: Urls.ForgotPassowrdPhoneUpdate(),
            data,
        })
    }
    ForgotPassowrdEmailUpdate = (data) => {
        return axiosInstance({
            method: 'post',
            url: Urls.ForgotPassowrdEmailUpdate(),
            data,
        })
    }
    TeacherRegisterByPhone = (data) => {
        return axiosInstance({
            method: 'post',
            url: Urls.TeacherRegisterByPhone(),
            data,
        })
    }
    StudentRegisterByPhone = (data) => {
        return axiosInstance({
            method: 'post',
            url: Urls.StudentRegisterByPhone(),
            data,
        })
    }
    StudentRegisterByEmail = (data) => {
        return axiosInstance({
            method: 'post',
            url: Urls.StudentRegisterByEmail(),
            data,
        })
    }
}
export default new LoginRegisterReq
